(()=>{
 'use strict';
 const product=window.FultonsSofaOptions?.['15887255208319'];
 const script=document.querySelector('script[src*="fultons-quiete-option-thumbnails.js"]');
 if(!product?.configurations?.length||!script?.src)return;

 // Quiete is the approved exception to the schematic-only Natuzzi treatment:
 // its seven completed, reviewed lifelike assets correspond to the seven
 // configured shapes. Other Natuzzi selectors continue to use clean supplier
 // schematics until an equally consistent model-specific set is approved.
 const files={
  '005':['fultons-quiete-005-153cm-option-finishmatch-v1-tight-v1.webp','Quiete 2-seater sofa, 153 cm — finish-matched model illustration','finish-matched-render'],
  '009':['fultons-quiete-009-194cm-option-supplier-v2-tight-v1.webp','Quiete 3-seater sofa, 194 cm — verified Natuzzi cutout','supplier-original'],
  '064':['fultons-quiete-064-219cm-option-finishmatch-v1-tight-v1.webp','Quiete large 3-seater sofa, 219 cm — finish-matched model illustration','finish-matched-render'],
  '016+001+011+001+017':['fultons-quiete-corner-306x306-option-finishmatch-v2-tight-v1.webp','Quiete corner composition 306 × 306 cm — finish-matched model illustration','finish-matched-render'],
  '286+489+287':['fultons-quiete-corner-237x237-option-finishmatch-v2-tight-v1.webp','Quiete corner composition 237 × 237 cm — finish-matched model illustration','finish-matched-render'],
  '100+001+011+017':['fultons-quiete-corner-237x232-open-option-finishmatch-v2-tight-v1.webp','Quiete open-end corner composition 237 × 232 cm — finish-matched model illustration','finish-matched-render'],
  '003':['fultons-quiete-003-82cm-option-finishmatch-v1-tight-v1.webp','Quiete armchair, 82 cm — finish-matched model illustration','finish-matched-render']
 };
 // Actual reviewed cutout proportions; these are perspective pictures, not floor plans.
 const aspects={'005':616/359,'009':781/370,'064':871/369,'016+001+011+001+017':870/292,'286+489+287':678/259,'100+001+011+017':674/279,'003':327/332};
 for(const configuration of product.configurations){
  const entry=files[String(configuration.configurationCode||'')];
  if(!entry)continue;
  configuration.pickerThumbnail=new URL(entry[0],script.src).href;
  configuration.pickerThumbnailAlt=entry[1];
  configuration.pickerThumbnailKind=entry[2];
  configuration.pickerThumbnailAspect=aspects[String(configuration.configurationCode)];
 }
})();
